import { styled } from '@lichtblick/styled';
import { TextProps } from '@lichtblick/types';

export const Wrapper = styled.span<TextProps>`
  color: ${({ color }) => color};
  font-family: 'Roboto', sans-serif;
  ${({ $variant }) => ({ ...$variant })}
`;
